import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserVehiclePatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserVehicleCollection {
  [IDataKeys.userVehicle]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserVehicleService {
  static createUserVehicle = (
    data: IUserVehiclePatchData
  ): Promise<IJSONAPIUserVehicleCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_VEHICLES,
          data,
        });
        resolve(response as IJSONAPIUserVehicleCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_VEHICLE);
        reject({ error });
      }
    });

  static getUserVehicles = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserVehicleCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_VEHICLES,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserVehicleCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_VEHICLES);
        reject({ error });
      }
    });

  static editUserVehicle = (
    id: string,
    data: IUserVehiclePatchData
  ): Promise<IJSONAPIUserVehicleCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_VEHICLE(id),
          data,
        });
        resolve(response as IJSONAPIUserVehicleCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_VEHICLE);
        reject({ error });
      }
    });

  static deleteUserVehicle = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_VEHICLE(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_VEHICLE);
        reject({ error });
      }
    });
}
